import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { HomePage } from "../home/HomePage";
import Media from "react-media";
import { FooterDesktop } from "../../components/footer/desktop/FooterDesktop";
import links from "../../components/footer/links.json";
import { FooterMobile } from "../../components/footer/mobile/FooterMobile";
import { Terminals } from "../terminals/Terminals";
import { AuthenticatedRoute } from "../AuthenticatedRoute";
import { Users } from "../users/Users";
import { ChangePassword } from "../change-password/ChangePassword";
import { AddUser } from "../add-user/firstStep/AddUser";
import { ChooseTerminal } from "../add-user/secondStep/ChooseTerminal";
import { UserDetails } from "../user-details/UserDetails";
import { ChooseTidUpdateOperation } from "../choose-tid-update-operation/ChooseTidUpdateOperation";
import { TermsAndCondition } from "../terms-and-conditions/TermsAndCondition";
import { pdfjs } from "react-pdf";
import { ResultPage } from "../result-page/ResultPage";
import { NotFoundPage } from "../not-found-page/NotFoundPage";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { ConfigProvider } from "../../services/configuration/ConfigProvider";
import ReactDOM from "react-dom";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import { CatalogPage } from "../catalog/CatalogPage";
import { ChooseTypeAddProduct } from "../add-product/firstStep/ChooseTypeAddProduct";
import { useLocation } from "react-router-dom";
import { MobileInfoAddProduct } from "../add-product/mobileInfo/MobileInfoAddProduct";
import { InsertProductDetails } from "../add-product/secondStep/InsertProductDetails";
import { CategoryDetailsPage } from "../category-details/CategoryDetailsPage";
import { ChooseProductCategories } from "../add-product/thirdStep/ChooseProductCategories";
import { ProductDetailPage } from "../product-details/ProductDetailPage";
import { MultiproductPage } from "../multiproduct-import/MultiproductPage";
import { AppUtils } from "../../utils/AppUtils";
import { SearchLayer } from "../../components/catalog-search-layer/SearchLayer";
import { dataStore } from "../../services/storage/DataStore";
import { IProductDto } from "../../models/ProductDto";
import $ from "jquery";
import { ICategoryDto } from "../../models/CategoryDto";
import { LoginPage } from "../login/LoginPage";
import { RegisterDev } from "../register-dev/RegisterDev";
import { SearchMainComponent } from "../../components/searchbar/SearchMainComponent";
import { SelectTerminalTypes } from "../add-user/AddUtilities/SelectTerminalTypes";
import { ChangePasswordUnauth } from "../reset-password/change-password-unauth/ChangePasswordUnauth";
import ResultPageUnauth from "../reset-password/result-page-unauth/ResultPageUnauth";
import { ApplicationDetail } from "../application-detail/ApplicationDetail";
import { Applications } from "../applications/Applications";
import ScrollToTop from "../../utils/ScrollToTop";
import { Merchants } from "../merchants/Merchants";
import RegisterDevResult from "../dev-account-request/RegisterDevResult";
import ActivateDevResult from "../add-user/devStep/activateDevResult/ActivateDevResult";
import { ActivateDev } from "../add-user/devStep/ActivateDev";
import CreateNewApp from "../addApp/CreateNewApp";
import AssignApp from "../assignApp/AssignApp";

function App() {
  // Init configuration env
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  // Disable caching for AJAX
  $(document).ready(function () {
    console.log("Disable caching...");
    $.ajaxSetup({ cache: false });
  });

  GoogleTagManagerService.getInstance().init();
  const location = useLocation();
  let cachedProducts: IProductDto[] | undefined = undefined;
  let cachedCatalog: string | undefined = undefined; // Stringified as JSON
  let tabChecked: boolean = false;
  let tryToInsertProduct: IProductDto | undefined = undefined;
  let categoryFromAddProduct: ICategoryDto | undefined = undefined;

  useEffect(() => {
    dataStore.getProductsDataObserver().subscribe((data) => {
      cachedProducts = data;
    });

    dataStore.getParsedCatalogObserver().subscribe((stringified: string | undefined) => {
      cachedCatalog = stringified;
    });

    dataStore.getTabSelectionObserver().subscribe((checked: boolean) => {
      tabChecked = checked;
    });

    dataStore.getTryToInsertProductObserver().subscribe((product: IProductDto | undefined) => {
      tryToInsertProduct = product;
    });

    dataStore.getCategoryFromAddProductObservable().subscribe((category: ICategoryDto | undefined) => {
      categoryFromAddProduct = category;
    });
  });

  ConfigProvider.getInstance().loadConfiguration(
    (config: { env: string; disableLog: any; mockData: any }) => {
      console.log("[App] current environment: " + config.env);
      if (config.disableLog) {
        console.log = () => { };
      }

      ReactDOM.render(
        <div id={"app"}>
          <Router>
            <div id={"app-parent"} className={"container-parent"}>
              <ScrollToTop />
              <Switch>
                <Route path="/login" component={LoginPage} />
                <Route path="/registerDev" component={RegisterDev} />
                <Route exact path="/termsAndConditions" component={TermsAndCondition} />
                <Route exact path="/changePasswordUnauth" component={ChangePasswordUnauth} />
                <Route exact path="/resultUnauth" component={ResultPageUnauth} />
                <Route exact path="/registerDevResult" component={RegisterDevResult} />
                <AuthenticatedRoute exact path="/" component={HomePage} />
                <AuthenticatedRoute exact path="/selectTerminalTypes" component={SelectTerminalTypes} />
                <AuthenticatedRoute exact path="/terminals" component={Terminals} />
                <AuthenticatedRoute exact path="/users" component={Users} />
                <AuthenticatedRoute exact path="/changePassword" component={ChangePassword} />
                <AuthenticatedRoute exact path="/search" component={SearchMainComponent} />
                <AuthenticatedRoute exact path="/addUser" component={AddUser} />
                <AuthenticatedRoute exact path="/activateDev" component={ActivateDev} />
                <AuthenticatedRoute exact path="/activateDevResult" component={ActivateDevResult} />
                <AuthenticatedRoute exact path="/chooseTerminal" component={ChooseTerminal} />
                <AuthenticatedRoute exact path="/users/:id?" component={UserDetails} />
                <AuthenticatedRoute exact path="/chooseTidOperation" component={ChooseTidUpdateOperation} />
                <AuthenticatedRoute exact path="/result" component={ResultPage} />
                <AuthenticatedRoute exact path="/catalog" component={(props: any) => {
                  return <CatalogPage cachedCatalog={cachedCatalog} tabSelected={tabChecked} {...props} />
                }} />
                <AuthenticatedRoute exact path="/catalog/search" component={SearchLayer} />
                <AuthenticatedRoute exact path="/category/:id?" component={(props: any) => {
                  return <CategoryDetailsPage cachedProducts={cachedProducts} {...props} />
                }} />
                <AuthenticatedRoute exact path="/addProduct/first" component={AppUtils.isPhoneOrTablet() ? MobileInfoAddProduct : ChooseTypeAddProduct} />
                <AuthenticatedRoute exact path="/addProduct/insertOrUpdate" component={(props: any) => {
                  return <InsertProductDetails dataCached={tryToInsertProduct} {...props} />
                }} />
                <AuthenticatedRoute exact path="/addProduct/categories" component={(props: any) => {
                  return <ChooseProductCategories choosenCategory={categoryFromAddProduct} {...props} />
                }} />
                <AuthenticatedRoute exact path="/addProduct/import" component={!AppUtils.isPhoneOrTablet() ? MultiproductPage : NotFoundPage} />
                <AuthenticatedRoute exact path="/products/:id?" component={ProductDetailPage} />
                <AuthenticatedRoute exact path="/" component={HomePage} />
                <AuthenticatedRoute exact path="/applications" component={Applications} />
                <AuthenticatedRoute exact path="/addApp" component={CreateNewApp} />
                <AuthenticatedRoute exact path="/assignApp" component={AssignApp} />
                <AuthenticatedRoute exact path="/applications/:id?" component={ApplicationDetail} />
                <AuthenticatedRoute exact path="/merchants" component={Merchants} />
                <Route exact path="/404" component={NotFoundPage} />
                <Route component={NotFoundPage} />
              </Switch>
            </div>
            <Media query="(max-width: 1064px)">
              {matches => {
                if (matches) {
                  /* Mobile */
                  if (location.pathname === '/login') {
                    return <FooterMobile menuItems={links.menu} supportLink={links.support} mainLink={links.nexi} />
                  } else {
                    // No show footer
                    return <div />
                  }
                } else {
                  /* Desktop */
                  if (location.pathname !== '/result') {
                    return <FooterDesktop menuItems={links.menu} supportLink={links.support} mainLink={links.nexi} />
                  } else {
                    return <div />
                  }
                }
              }}
            </Media>
          </Router>
        </div>
        , document.getElementById("root"));
    }, () => {
      ReactDOM.render(<ServiceUnavailablePage />, document.getElementById("root"));
    });

  return <div id="root"></div>;
}

export default App;
